import { Expose, Type } from 'class-transformer';
import { CompanyAddressDto } from './company-address.dto';
import { CompanySocialMediaDto } from './company-social-media.dto';

export class UpdateCompanyResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'logo' })
  logo: string;
  @Expose({ name: 'website' })
  website: string;
  @Expose({ name: 'industry' })
  industry: string;
  @Expose({ name: 'expertise' })
  expertise: string;
  @Expose({ name: 'invite_link' })
  inviteLink: string;
  @Expose({ name: 'address' })
  @Type(() => CompanyAddressDto)
  address: CompanyAddressDto;
  @Expose({ name: 'social_media' })
  @Type(() => CompanySocialMediaDto)
  socialMedia: CompanySocialMediaDto;
}
